// extracted by mini-css-extract-plugin
export default {"list":"Hqdl5","itemContainer":"j1Ozt","item":"YJku2"};